/**
 * useReferral - Fetches and exposes the authenticated user's referral info.
 * @returns {{ referralCode, referralLink, referralCount, loading, refresh }}
 * @atomic
 */
import { useState, useEffect, useCallback } from 'react'
import { authAPI } from '../services/api'
import { createLogger } from '../utils/logger'

const logger = createLogger('useReferral')

export default function useReferral() {
  const [referralCode, setReferralCode] = useState(null)
  const [referralLink, setReferralLink] = useState(null)
  const [referralCount, setReferralCount] = useState(0)
  const [loading, setLoading] = useState(false)

  const fetch = useCallback(async () => {
    setLoading(true)
    try {
      const res = await authAPI.getReferralInfo()
      setReferralCode(res.data.referralCode)
      setReferralLink(res.data.referralLink)
      setReferralCount(res.data.referralCount)
    } catch (err) {
      logger.error('Failed to load referral info', err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { fetch() }, [fetch])

  return { referralCode, referralLink, referralCount, loading, refresh: fetch }
}
